export enum AgentCode {
  EzyMedical = '8OI00003',
  iMedicalCard = '8OT00003',
  EasyHealth = 'KEI UAT',
}
